<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import type { Country, Inventory, Membership } from '../api/types'
  import { loadingChange, loadingCancel } from './store'
  import { tab, TAB } from '../elements'
  import { handleCurrencySign } from '../helpers'

  export let membership: Membership
  export let userCountry: Country
  export let hasEnthusiastFeature
  export let isDuckCreekSource
  export let hdcId
  export let sourceSystem

  $: subscriptionActive = membership?.subscription?.status === 'active'

  const currency = handleCurrencySign(userCountry)

  const dispatch = createEventDispatcher()

  const handleChangeRenewal = () => dispatch('changeRenewalPlan')
</script>

<style>
  table {
    width: 100%;
    border-collapse: collapse;
  }

  table th,
  .label {
    color: #8e949a;
    font-weight: 500;
    line-height: 16px;
    padding-bottom: 8px;
    text-align: left;
  }

  .text-center {
    text-align: center;
  }

  .label {
    display: inline-block;
  }

  table td {
    color: #090a0b;
    font-style: normal;
    font-weight: normal;
    line-height: 22px;
    padding-bottom: 28px;
  }

  .membership-status {
    color: #007bb3;
  }

  .add-membership {
    color: #007bb3;
    cursor: pointer;
    line-height: 22px;
  }

  .renewal-plan-entry {
    color: #007bb3;
    cursor: pointer;
    font-weight: 500;
    line-height: 24px;
    padding: 8px 16px;
    border: 1px solid #dee0e2;
    border-radius: 4px;
    display: inline-block;
    margin-top: 24px;
  }

  .flex {
    display: flex;
    justify-content: space-around;
  }
</style>

<table>
  <tbody>
  <tr>
    <th>Membership #</th>
    <th>Level</th>
    <th>Since</th>
  </tr>
  <tr>
    <td data-cy="membership-id">{hdcId}</td>
    <td data-cy="membership-name">
      {#if membership}
        {membership?.name}
      {:else}
        <span class="add-membership" on:click={() => tab.set(TAB.CHANGE)}>Add Membership</span>
      {/if}
    </td>
    <td data-cy="membership-effective">
      {membership ? new Date(membership.effectiveAt).toLocaleDateString() : 'N/A'}
    </td>
  </tr>
  <tr>
    <th>{subscriptionActive ? 'Renews On' : 'Expires On'}</th>
    <th>Price</th>
    <th>Term</th>
  </tr>
  <tr>
    <td data-cy="membership-expire">{membership ? new Date(membership.expireAt).toLocaleDateString() : 'N/A'}</td>
    <td data-cy="membership-price">{membership ? `${currency} ${(membership.price / 100).toFixed(2)}` : 'N/A'}</td>
    <td data-cy="membership-term">
      {#if membership && !/^process.env.LIFETIME_VIP_SKU/.test(membership.skuCode)}
        1 year
      {:else}
        N/A
      {/if}
    </td>
  </tr>
  </tbody>
</table>

{#if hasEnthusiastFeature}
  <div class="flex">
    <div class="text-center">
      <p style="margin: 0;">
        {#if isDuckCreekSource}
          <span class="label">Note</span>
          <br />
          <span>See Duck Creek to manage</span>
        {:else if $loadingCancel}
          <span class="label">Note</span>
          <br />
          <span>Upgrade to membership is in progress</span>
        {:else if $loadingCancel}
          <span class="label">Note</span>
          <br />
          <span>Cancellation to membership is in progress</span>
        {:else if membership?.subscription}
          <span class="label">Note</span>
          <br />
          {#if !subscriptionActive}
            <span data-test="subscription-status">Auto-Renew Disabled</span>
          {/if}
        {:else}
          <span class="label">Note</span>
          <br />
          <span>N/A</span>
        {/if}
      </p>
    
      {#if subscriptionActive && !isDuckCreekSource}
        <div class="renewal-plan-entry noselect" on:click={handleChangeRenewal} data-test="change-subscription">
          Change renewal plan
        </div>
      {/if}
    </div>
    <div class="text-center">
      <p style="margin: 0;">
        <span class="label">Source</span>
        <br/>
        {sourceSystem ?? 'N/A'}
      </p>
    </div>
  </div>
{/if}

{#if !hasEnthusiastFeature}
  <p style="margin: 0;">
    {#if $loadingChange}
      <span class="label membership-status">Note</span>
      <br />
      <span>Upgrade to membership is in progress</span>
    {:else if $loadingCancel}
      <span class="label membership-status">Note</span>
      <br />
      <span>Cancellation to membership is in progress</span>
    {:else if membership?.subscription}
      <span class="label membership-status">Note</span>
      <br />
      {#if !subscriptionActive}
        <span data-test="subscription-status">Auto-Renew Disabled</span>
      {/if}
    {/if}
  </p>

  {#if subscriptionActive}
    <div class="renewal-plan-entry noselect" on:click={handleChangeRenewal} data-test="change-subscription">
      Change renewal plan
    </div>
  {/if}
{/if}
